import { render, staticRenderFns } from "./FXRateLogs.vue?vue&type=template&id=8c6795fe&scoped=true"
import script from "./FXRateLogs.vue?vue&type=script&lang=js"
export * from "./FXRateLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6795fe",
  null
  
)

export default component.exports